/** @jsx isolateComponent */
import { isFunction } from 'lodash';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Typography } from '@zapier/design-system';
import Surface from '@zapier/product-get-help/esm/components/shared/Surface';
import GeneralDocs from './GeneralDocs';
import AppDocs from './AppDocs';
const Styles = () => ({
    title: Object.assign(Object.assign({}, Typography.sectionHeader1), { color: Colors.gray }),
    children: Object.assign(Object.assign({}, Typography.paragraph3), { color: Colors.neutral800 }),
    root: {
        display: 'grid',
        gridGap: 20,
    },
});
/** Renders the content for the docs-step in the form. */
const DocsStep = ({ size = 'large', title, children, links, apps, }) => {
    return (isolateComponent(Surface, { size: size, title: title },
        isolateComponent("div", { css: Styles().root },
            isolateComponent("div", { css: Styles().children }, isFunction(children) ? children() : children),
            links && links.length > 0 && isolateComponent(GeneralDocs, { links: links }),
            apps && apps.length > 0 && isolateComponent(AppDocs, { apps: apps }))));
};
export default DocsStep;
